import { Configuration, PublicClientApplication } from "@azure/msal-browser";

let configResponse: any;

const isPlaceholder = (value: unknown) => typeof value === 'string' && value.startsWith('#{') && value.endsWith('}#');

const getConfig = async () => {
  if (configResponse) {
    return configResponse;
  }

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error('config.json not found, falling back to environment variables.');
    }
    const configFromFile = await response.json();

    if (isPlaceholder(configFromFile.auth.REACT_APP_AZURE_CLIENT_ID)) {
      throw new Error('Placeholder values found in config.json, falling back to environment variables.');
    }
    
    configResponse = configFromFile;

  } catch (error) {
    console.warn((error as Error).message);
    configResponse = {
      auth: {
        REACT_APP_AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID || "",
        REACT_APP_UI_LOGIN_AUTHORITY: process.env.REACT_APP_UI_LOGIN_AUTHORITY || "",
        REACT_APP_UI_LOGIN_SCOPE: process.env.REACT_APP_UI_LOGIN_SCOPE || "",
        REACT_APP_UI_KNOWN_AUTHORITIES: process.env.REACT_APP_UI_KNOWN_AUTHORITIES || "",
        REACT_APP_AZURE_REDIRECT_URI: process.env.REACT_APP_AZURE_REDIRECT_URI || "",
      },
      app: {
        REACT_APP_ALLYIQ_URL: process.env.REACT_APP_ALLYIQ_URL || "",
      }
    };
  }
  return configResponse;
};


// MSAL B2C Login configuration - Initial empty config
export const msalConfig: Configuration = {
    auth: {
        clientId: "",
        authority: "",
        knownAuthorities: [],
        redirectUri: "/",
        postLogoutRedirectUri: "/", // Redirects to root after logout
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

// Scopes will also be loaded dynamically
export let loginRequest = {
    scopes: [""]
};

export let apiRequest = {
    scopes: ["openid", "offline_access", ""]
};

export let msalInstance: PublicClientApplication;

/**
 * Initializes MSAL instance with async config.
 */
export const initializeMsal = async (): Promise<PublicClientApplication> => {
  if (msalInstance) {
    return msalInstance;
  }

  const config = await getConfig();
  
  msalConfig.auth.clientId = config.auth.REACT_APP_AZURE_CLIENT_ID;
  msalConfig.auth.authority = config.auth.REACT_APP_UI_LOGIN_AUTHORITY;
  msalConfig.auth.knownAuthorities = [config.auth.REACT_APP_UI_KNOWN_AUTHORITIES];
  msalConfig.auth.redirectUri = config.auth.REACT_APP_AZURE_REDIRECT_URI;

  loginRequest.scopes = [config.auth.REACT_APP_UI_LOGIN_SCOPE];
  apiRequest.scopes = ["openid", "offline_access", config.auth.REACT_APP_UI_LOGIN_SCOPE];

  msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();
  return msalInstance;
};

/** AllyIQ home URL for the header logo; empty when the environment hasn't set one. */
export const getAllyIqUrl = async (): Promise<string> => {
  const url = (await getConfig()).app?.REACT_APP_ALLYIQ_URL;
  return typeof url === 'string' && !isPlaceholder(url) ? url : '';
};
